<div class="page">
  <div class="page__container " #page>
    <h1 class="page__title h2">{{ 'smsadv_title' | translate }}</h1>
    <!-- step -->
    <wsb-atlas-step class="mb-5" [numSteps]="3" [currentStep]="currentTab"></wsb-atlas-step>
    <div [ngSwitch]="currentTab">
      <!-- step1: choose recipients -->
      <wsb-sms-adv-select-recipients
        *ngSwitchCase="1"
        [smsAdvCampaignToSend]="smsAdvCampaignToSend"
        (enableProceedBtn)="isEnableProceedBtn($event)"
      ></wsb-sms-adv-select-recipients>
      <!-- step2: create campaign -->
      <wsb-sms-adv-create-campaign
        *ngSwitchCase="2"
        [smsAdvCampaignToSend]="smsAdvCampaignToSend"
        (enableProceedBtn)="isEnableProceedBtn($event)"
      ></wsb-sms-adv-create-campaign>
      <!-- step3: summary -->
      <wsb-sms-adv-summary-campaign
        *ngSwitchCase="3"
        [smsAdvCampaignToSend]="smsAdvCampaignToSend"
        (isEnableSendBtn)="isEnableSendBtn($event)"
      ></wsb-sms-adv-summary-campaign>
    </div>
    <!-- footer -->
    <div class="page__actions  actions-bar" #actionsBar style="z-index: 3">
      <span class="actions-bar__bg"></span>
      <div class="actions-bar__container" toastContainer></div>
      <div class="actions-bar__container  actions-bar__container--actions">
        <div class="d-flex justify-content-between">
          <div class="d-flex">
            <!-- proceed button -->
            <button
              #submitBtn
              class="btn btn-primary btn-sm"
              *ngIf="currentTab !== 3"
              (click)="btnProceed()"
              [disabled]="!proceedBtnEnabled"
            >
              {{ 'common_next' | translate }}
            </button>
            <!-- send button -->
            <button #submitBtn class="btn btn-primary btn-sm" *ngIf="currentTab === 3" (click)="btnSend()">
              {{ 'common_send' | translate }}
            </button>
            <!-- save draft button -->
            <button
              #submitBtn1
              class="btn btn-primary ms-3 btn-sm"
              *ngIf="currentTab === 2 || currentTab === 3"
              [disabled]="!proceedBtnEnabled"
              (click)="btnSaveDraft()"
            >
              {{ 'smsadv_send_draft_button' | translate }}
            </button>
            <!-- back button -->
            <button class="btn   btn-secondary ms-3 btn-sm" *ngIf="currentTab !== 1" (click)="backButton()">
              {{ 'common_back' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
